export default "__VITE_ASSET__BYSEDrLD__"